import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/buttons/buttons";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import EmptyRestaurant from "../../../../../assets/images/emptyState/restaurant.svg";
import { getABusiness } from "../../../../../redux/business/businessActions";

export default function RestaurantBusiness({ myBusiness }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { business, isLoading } = useSelector((state) => state.business);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (myBusiness?.id) {
      dispatch(getABusiness(myBusiness?.id));
    }
  }, [dispatch, myBusiness]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((restaurant, index) => {
        let single = {
          location: restaurant?.restaurant_city,
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: restaurant?.restaurant_name,
          phone: <div>{restaurant?.restaurant_phone}</div>,
          approval:
            restaurant?.management_approved === true ? (
              <p className="font-bold text-sm text-green-500">Approved</p>
            ) : (
              <p className="font-bold text-sm text-primary">Unapproved</p>
            ),

          email: restaurant?.restaurant_email,
          restaurant: restaurant,
        };

        outputArray.push({ single });
        return true;
      });

      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(business?.restaurants);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business]);

  const goToCreate = () => {
    navigate(`/create-restaurant`);
  };

  // const goToSinglePage = (params) => {
  //   let id = params?.single?.business?.id;
  //   navigate(`/admin/store/${id}`);
  // };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "single.num",
          },
          {
            Header: "Name",
            accessor: "single.name",
          },
          {
            Header: "Email",
            accessor: "single.email",
          },
          {
            Header: "Location",
            accessor: "single.location",
          },
          {
            Header: "Status",
            accessor: "single.approval",
          },
          {
            Header: "Phone Number",
            accessor: "single.phone",
          },
        ],
      },
    ],
    []
  );
  return (
    <div data-test="business-page ">
      <div className="bg-white dark:bg-[#121212] rounded-md py-4">
        <div className="flex items-end justify-end mx-6 py-3 ">
          <Button.Primary
            title={"Create Restaurant"}
            onClick={() => goToCreate()}
          />
        </div>
        <div className="border-b"></div>

        <div>
          {data?.length > 0 ?
            (<>
              {isLoading ? (
                <TableSkeleton />
              ) : (
                <Table
                  columns={columns}
                  data={data?.length > 0 ? data : []}
                  onClick={()=>{}}
                  className="w-full"
                  // rowClass="hover:shadow-md cursor-pointer"
                />
              )}
            </>)
            :
            (<div className="text-center">
              <div className="flex justify-center my-12 ">
                <img src={EmptyRestaurant} alt="restaurant" />
              </div>
              <p className="font-bold text-xl my-3">Restaurants</p>
              <p className="text-sm text-gray-500">
                Your business has no restaurants yet
              </p>
            </div>)
          }
        </div>
      </div>
    </div>
  );
}
